import React from 'react';
import Select from 'react-select';
import { FormProvider, Controller } from 'react-hook-form';
import { ModalHeader, ModalBody, ModalFooter } from '@/components/common/Modal/types';
import Button from '@/components/common/Button';
import Input from '@/components/common/Input';

export const renderUserFormHeader: ModalHeader = {
	title: 'Add/Edit User'
}
export const renderUserFormBody = ({ userMethods }, userId, roles, submitModal): ModalBody => ({
	children: (
			<form onSubmit={userMethods.handleSubmit(() => submitModal())} className="flex flex-col items-start pt-3 px-8 gap-4">
				<FormProvider {...userMethods}>
				<Input expanded
							 name="userName"
							 type="text"
							 label="Name"
							 placeholder="Fill Name"
							 {...userMethods.register('userName', { required: 'Username can\'t be empty' })}/>
				<Input expanded
							 name="phoneNumber"
							 type="text"
							 label="No. HP"
							 placeholder="e.g +62812345678990"
							 {...userMethods.register('phoneNumber', { required: 'Phone number can\'t be empty' })}/>
				<Input expanded
							 name="email"
							 type="email"
							 label="Email"
							 placeholder='e.g yourname@yourmail.com'
							 {...userMethods.register('email', { required: 'Email can\'t be empty' })}/>
				<div className='flex flex-col w-full gap-2'>
					<p className='font-medium text-sm'>Role</p>
					<Controller
						name='role'
						render={({ field }) =>
							<Select
								styles={{
									control: style => ({ ...style, width: '100%' }),
								}}
								options={ roles }
								placeholder='Choose role'
								{...userMethods.register('role', { required: 'Role must be selected' })}
								{...field}
							/>
						}
					/>
				</div>
				</FormProvider>
			</form>
	),
	data: { value: { id: userId } }
})
export const renderUserFormFooter = (closeModal, submitModal) : ModalFooter => ({
	children: (
		<div className="flex justify-between items-center w-full p-8 gap-3">
			<Button type="button" variant="basic" onClick={closeModal()}>Batal</Button>
			<Button type="submit" variant="primary" onClick={submitModal()}>Simpan</Button>
		</div>
	)
})
